import styled, { css } from 'styled-components';
import media from '../../../constants/media';
import fluid from '../../../helpers/fluid';

const baseHeading = css`
	color: ${props => props.theme.colors.primary};
	line-height: 1.07;
	letter-spacing: 0;
	color: ${({ theme }) => theme.colors.black};
	margin-top: ${({ marginTop }) => marginTop || 0};
	margin-bottom: ${({ marginBottom }) => marginBottom || 0};
	word-break: break-word;

	${media.mobileOnly`
		word-wrap: break-word;
	`};
`;

const asHeading1 = css`
	${baseHeading};
	${fluid('font-size', '30px', '46px', '320px', '1024px')};
	font-family: ${({ theme }) => theme.fonts.ArimoBold};
`;

const asHeading2 = css`
	${baseHeading};
	${fluid('font-size', '28px', '40px', '320px', '1024px')};
	font-family: ${({ theme }) => theme.fonts.ArimoBold};
`;

const asHeading3 = css`
	${baseHeading};
	${fluid('font-size', '26px', '32px', '320px', '1024px')};
	font-family: ${({ theme }) => theme.fonts.ArimoBold};
`;

const asHeading4 = css`
	${baseHeading}
	${fluid('font-size', '20px', '20px', '320px', '1024px')};
	font-family: ${({ theme }) => theme.fonts.ArimoBold};
`;

const asHeading5 = css`
	${baseHeading};
	${fluid('font-size', '20px', '20px', '320px', '1024px')};
	font-family: ${({ theme }) => theme.fonts.ArimoMedium};
`;

const asHeading6 = css`
	${baseHeading};
	${fluid('font-size', '18px', '18px', '320px', '1024px')};
	font-family: ${({ theme }) => theme.fonts.ArimoMedium};
`;

const H1 = styled.h1`
	${asHeading1}
`;
const H2 = styled.h2`
	${asHeading2}
`;
const H3 = styled.h3`
	${asHeading3}
`;
const H4 = styled.h4`
	${asHeading4}
`;
const H5 = styled.h5`
	${asHeading5}
`;
const H6 = styled.h6`
	${asHeading6}
`;

export { asHeading1, asHeading2, asHeading3, asHeading4, asHeading5, asHeading6, H1, H2, H3, H4, H5, H6 };
